import DropzoneProfilePhoto from './DropzoneProfilePhoto.component';

export default DropzoneProfilePhoto;
